import React, { useContext, useEffect, useState } from 'react';
import { SocialLink, SocialText, SocialWrapper } from './styled';
import MailIcon from 'assets/svg/email-circle-ic.svg';
import LinkIcon from 'assets/svg/copy-link-circke-ic.svg';
import WAIcon from 'assets/svg/whatsapp-circle-ic.svg';
import FBIcon from 'assets/svg/facebook-circle-ic.svg';
import { useLocale } from 'locale';
import { routeContext } from 'react-router5';
import { shareHandler, ShareType } from 'helpers/share-helpers';
import { isCommercialBulletin } from 'utils/marketplaceRoutes';
import { Route } from 'config/routes';
import { isServer } from 'utils';
import { BulletinStatusType, IUserListingsByStatus } from 'utils/entities';
import { connect } from 'react-redux';
import { State } from 'store/state';
import { userListingsByStatusSelector } from 'store/state/domainData/selectors';
import CopyToClipboard from 'react-copy-to-clipboard';
import config from 'config';
import { CopyTooltip } from 'components/upload-bulletin/after-upload-modal/styled';
import { SmallText } from 'ds/components/typography';
import { useScreenBreakpoint } from 'consts/breakpoints';

export const SocialLinksBase: React.FC<{ bulletins: IUserListingsByStatus }> = ({ bulletins }) => {
  const { t } = useLocale();
  const router = useContext(routeContext);
  const isDevice = useScreenBreakpoint() < 3;
  const [ copied, setCopied ] = useState<boolean | null>(null);
  const activeListings = bulletins && bulletins[BulletinStatusType.Displayed] || [];
  const poi = activeListings && activeListings.length ? activeListings[0] : null;

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (copied) {
      timer = setTimeout(() => setCopied(null), 4000);
    }
    return () => clearTimeout(timer);
  }, [ copied, setCopied ]);

  const handleOnCopy = React.useCallback(() => {
    if (!copied) setCopied(true);
    return false;
  }, [ copied, setCopied ]);

  const onSocialShare = (type: ShareType) => (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (poi) {
      const url = `${config.oldILRoot}${router.router.buildUrl(isCommercial ? Route.UnitPageCommercial : Route.UnitPage, { id: poi.id })}`;
      shareHandler({ type, url, shareViaEmailOptions: { poi, t , url } });
    }
  };

  if (!poi) return null;

  const isCommercial: boolean = isCommercialBulletin(poi);
  const linkRoute = isCommercial ? Route.UnitPageCommercial : Route.UnitPage;
  const copyText = isServer() ? '' : (window.location.origin + router.router.buildUrl(linkRoute, { id: poi.id }));

  const renderTooltip = () => copied ? (
    <CopyTooltip>
      <SmallText>{t('content.copied')}</SmallText>
    </CopyTooltip>
  ) : null;

  return (
    <SocialWrapper>
      <SocialLink onClick={onSocialShare(ShareType.Facebook)}>
        <FBIcon />
        <SocialText>{t('payment.success.modal.social.fb')}</SocialText>
      </SocialLink>
      {isDevice ? (
        <SocialLink onClick={onSocialShare(ShareType.WhatsApp)}>
          <WAIcon />
          <SocialText>{t('payment.success.modal.social.whatsapp')}</SocialText>
        </SocialLink>
      ) : null}
      <CopyToClipboard text={copyText} onCopy={handleOnCopy}>
        <SocialLink>
          <LinkIcon />
          <SocialText>{t('payment.success.modal.social.link')}</SocialText>
          {renderTooltip()}
        </SocialLink>
      </CopyToClipboard>
      <SocialLink onClick={onSocialShare(ShareType.Email)}>
        <MailIcon />
        <SocialText>{t('payment.success.modal.social.mail')}</SocialText>
      </SocialLink>
    </SocialWrapper>
  );
};

const mapStateToProps = (state: State) => ({
  bulletins: userListingsByStatusSelector(state),
});

export const SocialLinks = connect(mapStateToProps)(SocialLinksBase);
